@if (sidebarElement(); as sidebarElement) {
  <mat-tab-group animationDuration="0ms" color="transparent" disablePagination>
    <mat-tab #componentsTab label="{{ 'Details' | transloco }}">
      <div class="sidebar-content--detail-tab">
        @if (guidelineComponent(); as guidelineComponent) {
          @if (guidelineComponent?.componentType === GuidelineComponentType.Criteria) {
            <sidebar-title-description
              data-testid="test"
              [description]="guidelineComponent.description"
              [showDescription]="sidebarElement.showDescription"
              [title]="guidelineComponent.title"
              (descriptionChange)="onDescriptionChanged($event)"
              (showDescriptionChange)="onShowDescriptionChange($event)"
              (titleChange)="onTitleChanged($event)" />

            <tt-divider class="tt-guideline-sidebar_divider" />

            <tt-guideline-component-sidebar-basics
              [attachments]="sidebarElement.attachments"
              [links]="sidebarElement.links"
              [references]="sidebarElement.references"
              [resourceTags]="sidebarElement.resourceTags"
              (basicsChanged)="handleBasicsChanged($event)" />

            @if (hasColorPresets()) {
              <tt-divider class="tt-guideline-sidebar_divider" />
              <div class="tt-guideline-sidebar_color-preset">
                <span>{{ 'Color' | transloco }}:</span>
                <tt-customisable-flowchart-element
                  [colorPresets]="colorPresets()"
                  [flowchartNodeConfig]="flowchartNodeConfig()"
                  (colorPresetChanged)="onColorPresetChanged($event)" />
              </div>
            }
          } @else if (guidelineComponent.componentType === GuidelineComponentType.Observation) {
            <sidebar-title-description
              [description]="guidelineComponent.description"
              [showDescription]="sidebarElement.showDescription"
              [title]="guidelineComponent.title"
              (descriptionChange)="onDescriptionChanged($event)"
              (showDescriptionChange)="onShowDescriptionChange($event)"
              (titleChange)="onTitleChanged($event)" />

            <tt-divider class="tt-guideline-sidebar_divider" />

            <guideline-sidebar-unit-molar
              [confirmationOnUnitChange]="true"
              [molarMass]="guidelineComponent.observationDefinition?.molarMass"
              [sourceDecision]="sidebarElement"
              [unit]="guidelineComponent.observationDefinition?.unit"
              (unitChanged)="onUnitMolarChanged($event)" />
            <tt-divider class="tt-guideline-sidebar_divider" />

            <tt-guideline-component-sidebar-basics
              [attachments]="guidelineComponent.attachments"
              [links]="sidebarElement.links"
              [references]="sidebarElement.references"
              [resourceTags]="sidebarElement.resourceTags"
              (basicsChanged)="handleBasicsChanged($event)" />
          }
        } @else if (sidebarElement.rule) {
          <sidebar-title-description
            [description]="sidebarElement.ruleDescription"
            [showDescription]="sidebarElement.showDescription"
            [title]="sidebarElement.ruleTitle"
            (descriptionChange)="onRuleDescriptionChanged($event)"
            (showDescriptionChange)="onShowDescriptionChange($event)"
            (titleChange)="onRuleTitleChanged($event)" />

          <tt-divider class="tt-guideline-sidebar_divider" />

          <legend>{{ 'Rule' | transloco }}:</legend>

          <div
            class="sidebar-content__rule--prettified"
            [innerHTML]="sidebarElement.rulePrettyfied | sanitizeHtml"
            (click)="editRule()"></div>
          <p class="sidebar-content__rule--note">Beta version</p>
          <tt-divider class="tt-guideline-sidebar_divider" />

          <tt-guideline-component-sidebar-basics
            [links]="sidebarElement.links"
            [references]="sidebarElement.references"
            [resourceTags]="sidebarElement.resourceTags"
            (basicsChanged)="handleBasicsChanged($event)" />
        }
      </div>
    </mat-tab>

    @if (!sidebarElement?.rule && !guidelineComponent()?.proposedComponent) {
      <mat-tab label="{{ 'TechnicalInfo' | transloco }}">
        @if (sidebarElement?.guidelineCriteria?.findingDefinition) {
          <sidebar-technical-info
            [guidelineComponent]="sidebarElement.guidelineCriteria.findingDefinition"
            [label]="'FindingDefinition' | transloco" />
        }
        @if (sidebarElement?.guidelineObservation?.observationDefinition) {
          <sidebar-technical-info
            [guidelineComponent]="sidebarElement.guidelineObservation.observationDefinition"
            [label]="'ObservationDefinition' | transloco" />
        }
      </mat-tab>
    }
  </mat-tab-group>
}
